import internalHttp from "../utility/internal-http";

const BASE = "/internal/v1/api-keys";

const List = async ({ page = 1, limit = 50, isActive, clientName } = {}) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (isActive !== undefined && isActive !== "") {
    params.set("isActive", String(isActive));
  }
  if (clientName) {
    params.set("clientName", clientName);
  }
  return internalHttp.get(`${BASE}?${params.toString()}`);
};

const GetById = async (id) => internalHttp.get(`${BASE}/${id}`);

const Create = async (payload) => internalHttp.post(BASE, payload, { silent: true });

const Update = async (id, payload) => internalHttp.put(`${BASE}/${id}`, payload);

const Regenerate = async (id) =>
  internalHttp.post(`${BASE}/${id}/regenerate`, {}, { silent: true });

const Deactivate = async (id) => internalHttp.delete(`${BASE}/${id}`);

const attributionPath = (id, segment) => `${BASE}/${id}/attribution/${segment}`;

const GetAttributionStats = async (id) =>
  internalHttp.get(attributionPath(id, "stats"), true);

const ListPatients = async (id, { page = 1, limit = 50, q } = {}) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (q) params.set("q", q);
  return internalHttp.get(`${attributionPath(id, "patients")}?${params}`, true);
};

const ListUsers = async (id, { page = 1, limit = 50, q } = {}) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (q) params.set("q", q);
  return internalHttp.get(`${attributionPath(id, "users")}?${params}`, true);
};

const ListPrescriptions = async (id, { page = 1, limit = 50, q } = {}) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (q) params.set("q", q);
  return internalHttp.get(`${attributionPath(id, "prescriptions")}?${params}`, true);
};

const partnerApiKeyService = {
  List,
  GetById,
  Create,
  Update,
  Regenerate,
  Deactivate,
  GetAttributionStats,
  ListPatients,
  ListUsers,
  ListPrescriptions,
};

export default partnerApiKeyService;
